<template>
  <div class="map-container" v-show="visible">
    <div class="map" :id="BMAP_CONTAINER_ID"></div>
    <poi-list
      :pois="pois"
      class="amap-poi-list"
      ref="amap-poi-list"
      @selectPoi="handleClickPoi"
    />
    <div class="back-icon" @click="handleBack">
      <img src="@assets/images/ic_back_center.svg" />
    </div>
  </div>
</template>

<script>
// 已迁移至百度地图
import bmapService, { BMAP_CONTAINER_ID } from '@stores/location/bmap';
import PoiList from '../ActiveForm/PoiList/PoiList.vue';
export default _extend({
  name: 'Amap',
  components: {
    PoiList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      BMAP_CONTAINER_ID,
      pois: [],
      amapInstance: bmapService // 保持变量名兼容
    };
  },
  methods: {
    async handleClickPoi(poi) {
      // 通过逆地理编码补充省市区信息
      const enrichedPoi = await this.amapInstance.enrichPoiWithAddress(poi);
      this.$emit('selectPoi', enrichedPoi);
    },
    handleBack() {
      this.$emit('back');
    }
  },
  computed: {
    currentLocation() {
      return this.amapInstance.currentLocation;
    },
    mapChange() {
      return {
        currentLocation: this.currentLocation,
        visible: this.visible,
        amapInstance: this.amapInstance
      };
    }
  },
  watch: {
    mapChange() {
      if (this.currentLocation) {
        this.amapInstance.placeSearch.setPageSize(30);

        this.amapInstance.searchNearby((status, result) => {
          if (status === 'complete') {
            this.pois = result.poiList.pois;
            if (this.pois.length && this.visible) {
              this.amapInstance.focusPoi(this.pois[0]);
              setTimeout(() => {
                this.amapInstance.panPoiToCenter(
                  0,
                  (window.innerHeight -
                    this.$refs['amap-poi-list'].$el.offsetHeight) *
                    -0.5
                );
              }, 200);
            }
          }
        });
      }
    }
  }
});
</script>

<style scoped lang="scss">
.map-container {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  .map {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }
  .amap-poi-list {
    position: absolute;
    bottom: 0px;
    left: 0;
    z-index: 100; // 确保在地图上方
    max-height: 511px;
    @media (max-height: 667px) {
      max-height: 439px;
    }
  }
  .back-icon {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 100;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
<style lang="scss">
.map-container {
  .custom-info-window {
    background-color: #000;
    color: #ffffff;
    border-radius: 8px;
    padding: 8px;
    white-space: nowrap;
    position: relative;
    &::after {
      border-width: 8px;
      border-color: #000 transparent transparent transparent;
      border-style: solid;
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/business/views/Amap/Amap.vue